// extracted by mini-css-extract-plugin
module.exports = {"alignGraphs":"DashboardGraphs_alignGraphs__2_hpQ"};